import { TranslocoTranspiler, DefaultTranspiler, TranspileParams } from '@jsverse/transloco';

export class TranslocoCustomTranspiler implements TranslocoTranspiler {
  defaultTranspiler: DefaultTranspiler = new DefaultTranspiler();

  transpile(params: TranspileParams): string {
    return this.defaultTranspiler.transpile(params);

    // Use for debugging
    //return `ŜŜ ${this.defaultTranspiler.transpile(params)} ŞŞ`;
  }
}
